module.exports = __webpack_public_path__ + "img/logo.c08344a.png";